
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
  {
    name: 'Carlos Mendoza',
    role: 'Empresario',
    location: 'Las Lomas, CDMX',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
    rating: 5,
    text: 'La automatización de mi casa ha sido un cambio total. Ahora llego a casa y todo está perfecto: la temperatura ideal, mi música favorita sonando y las luces creando el ambiente perfecto. El ahorro en mi recibo de luz ha sido impresionante.',
    project: 'Automatización Completa - Residencial',
    savings: '40% ahorro energético',
    highlight: 'Comodidad y ahorro excepcional'
  },
  {
    name: 'María Elena Rodríguez',
    role: 'Arquitecta',
    location: 'Polanco, CDMX',
    image: 'https://images.unsplash.com/photo-1735835138452-60dad7553022?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MTg3MTl8MHwxfHNlYXJjaHwxfHxBJTIwY3JvcHBlZCUyMGltYWdlJTIwb2YlMjBhJTIwcGVyc29uJTI3cyUyMGZhY2UlMkMlMjBsaWtlbHklMjBhJTIwcG9ydHJhaXQufGVufDB8fHx8MTc1MjU0MTgxMXww&ixlib=rb-4.1.0&q=80&w=200$w=100',
    rating: 5,
    text: 'El profesionalismo del equipo de Automatiza.me es excepcional. Desde el primer día entendieron mis necesidades y crearon una solución perfecta. Mi penthouse ahora es un ejemplo de tecnología y diseño integrados.',
    project: 'Penthouse Inteligente',
    savings: '35% ahorro energético',
    highlight: 'Profesionalismo excepcional'
  },
  {
    name: 'Roberto Sánchez',
    role: 'Director General',
    location: 'Santa Fe, CDMX',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    rating: 5,
    text: 'La automatización de nuestras oficinas ha mejorado significativamente la productividad. El control de acceso, la climatización inteligente y los sistemas de conferencia funcionan perfectamente. La inversión se pagó sola en menos de un año.',
    project: 'Oficina Corporativa',
    savings: '50% ahorro energético',
    highlight: 'ROI en menos de un año'
  },
  {
    name: 'Ana Sofía García',
    role: 'Médica',
    location: 'Coyoacán, CDMX',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&h=100&fit=crop&crop=face',
    rating: 5,
    text: 'Mi cocina inteligente ha transformado completamente mi rutina diaria. Los electrodomésticos se coordinan perfectamente, la iluminación se adapta a cada actividad y el control por voz lo hace todo tan fácil. Es como tener un asistente personal.',
    project: 'Cocina Inteligente',
    savings: '25% ahorro energético',
    highlight: 'Rutina diaria transformada'
  },
  {
    name: 'Luis Fernando Torres',
    role: 'Consultor',
    location: 'Roma Norte, CDMX',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face',
    rating: 5,
    text: 'Mi estudio ahora es el lugar perfecto para trabajar. La iluminación se ajusta automáticamente durante el día, la temperatura es siempre ideal y el sistema de audio me permite tener videoconferencias profesionales sin problemas.',
    project: 'Estudio Profesional',
    savings: '30% ahorro energético',
    highlight: 'Productividad mejorada 40%'
  },
  {
    name: 'Patricia Morales',
    role: 'Diseñadora',
    location: 'Condesa, CDMX',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
    rating: 5,
    text: 'La automatización de mi recámara ha mejorado significativamente mi calidad de sueño. Las luces se atenúan gradualmente, la temperatura se ajusta automáticamente y despierto con mi música favorita. Es como vivir en el futuro.',
    project: 'Recámara Inteligente',
    savings: '30% ahorro energético',
    highlight: 'Mejor calidad de sueño'
  }];


  const companyStats = [
  { number: '25', label: 'Años de Experiencia', icon: '🏆' },
  { number: '500+', label: 'Clientes Satisfechos', icon: '😊' },
  { number: '98%', label: 'Satisfacción Garantizada', icon: '✅' },
  { number: '24/7', label: 'Soporte Técnico', icon: '🛠️' }];


  return (
    <section id="testimonios" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50" data-id="jyvtszai5" data-path="src/components/Testimonials.tsx">
      <div className="container mx-auto px-4" data-id="ze7psr8ym" data-path="src/components/Testimonials.tsx">
        {/* Header */}
        <div className="text-center mb-16" data-id="5vo09s6dt" data-path="src/components/Testimonials.tsx">
          <Badge className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 text-sm font-medium mb-4" data-id="9s2fquxaw" data-path="src/components/Testimonials.tsx">
            💬 Testimonios Reales
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" data-id="j2t1ibxk1" data-path="src/components/Testimonials.tsx">
            Lo que Dicen Nuestros
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" data-id="nw9pyr416" data-path="src/components/Testimonials.tsx"> Clientes</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="bnlm8m6j3" data-path="src/components/Testimonials.tsx">
            Descubre por qué cientos de familias y empresas confían en nosotros para transformar sus espacios 
            en hogares y oficinas inteligentes.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="bjtwri1bz" data-path="src/components/Testimonials.tsx">
          {testimonials.map((testimonial, index) =>
          <Card key={index} className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden h-full" data-id="3g7ms71nx" data-path="src/components/Testimonials.tsx">
              <CardContent className="p-6 h-full flex flex-col" data-id="nhm71peeu" data-path="src/components/Testimonials.tsx">
                {/* Header */}
                <div className="flex items-center space-x-4 mb-4" data-id="53uso2c5m" data-path="src/components/Testimonials.tsx">
                  <Avatar className="w-12 h-12" data-id="ihlk4hte8" data-path="src/components/Testimonials.tsx">
                    <AvatarImage src={testimonial.image} alt={testimonial.name} data-id="ptnbpekjo" data-path="src/components/Testimonials.tsx" />
                    <AvatarFallback data-id="df2keii46" data-path="src/components/Testimonials.tsx">{testimonial.name.split(' ').map((n) => n[0]).join('')}</AvatarFallback>
                  </Avatar>
                  <div className="flex-1" data-id="e4mhs4j7q" data-path="src/components/Testimonials.tsx">
                    <h4 className="font-semibold text-gray-900" data-id="6ecibmpjx" data-path="src/components/Testimonials.tsx">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600" data-id="85glg4d9p" data-path="src/components/Testimonials.tsx">{testimonial.role}</p>
                    <p className="text-xs text-gray-500" data-id="m7ytucyil" data-path="src/components/Testimonials.tsx">{testimonial.location}</p>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4" data-id="dhbst7frh" data-path="src/components/Testimonials.tsx">
                  {[...Array(testimonial.rating)].map((_, i) =>
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="24bwqigt7" data-path="src/components/Testimonials.tsx" />
                )}
                </div>

                {/* Quote */}
                <div className="flex-1 mb-4" data-id="d22lizcqk" data-path="src/components/Testimonials.tsx">
                  <Quote className="w-6 h-6 text-blue-600 mb-2 opacity-50" data-id="e2gqrabvr" data-path="src/components/Testimonials.tsx" />
                  <p className="text-gray-700 leading-relaxed text-sm italic" data-id="wz1ehr3u3" data-path="src/components/Testimonials.tsx">
                    "{testimonial.text}"
                  </p>
                </div>

                {/* Project Info */}
                <div className="space-y-3" data-id="6q7ck9ldv" data-path="src/components/Testimonials.tsx">
                  <div className="flex items-center justify-between" data-id="qstz0p6yh" data-path="src/components/Testimonials.tsx">
                    <Badge variant="outline" className="text-xs" data-id="7au6xbvue" data-path="src/components/Testimonials.tsx">
                      {testimonial.project}
                    </Badge>
                  </div>
                  
                  <div className="flex flex-wrap gap-2" data-id="gbnnl8iyh" data-path="src/components/Testimonials.tsx">
                    <Badge className="text-xs bg-green-100 text-green-700" data-id="cxxaoe21m" data-path="src/components/Testimonials.tsx">
                      {testimonial.savings}
                    </Badge>
                    <Badge className="text-xs bg-blue-100 text-blue-700" data-id="26sa6zkdf" data-path="src/components/Testimonials.tsx">
                      {testimonial.highlight}
                    </Badge>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Company Stats */}
        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-xl" data-id="h1ntu95ch" data-path="src/components/Testimonials.tsx">
          <div className="text-center mb-8" data-id="lvzlt786v" data-path="src/components/Testimonials.tsx">
            <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="8wgelbxby" data-path="src/components/Testimonials.tsx">
              Por Qué Confían en Nosotros
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="g2smeq06a" data-path="src/components/Testimonials.tsx">
              Más de dos décadas de experiencia nos respaldan como líderes en automatización del hogar.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8" data-id="i90yr66f0" data-path="src/components/Testimonials.tsx">
            {companyStats.map((stat, index) =>
            <div key={index} className="text-center" data-id="dqam8m05g" data-path="src/components/Testimonials.tsx">
                <div className="text-4xl mb-4" data-id="1l4lw0kag" data-path="src/components/Testimonials.tsx">{stat.icon}</div>
                <div className="text-4xl font-bold text-blue-600 mb-2" data-id="odkm4mzg2" data-path="src/components/Testimonials.tsx">{stat.number}</div>
                <div className="text-gray-600 font-medium" data-id="y89vptp6j" data-path="src/components/Testimonials.tsx">{stat.label}</div>
              </div>
            )}
          </div>
        </div>

        {/* Trust Section */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 lg:p-12 text-white" data-id="3qoix5pp4" data-path="src/components/Testimonials.tsx">
          <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="gde79a40f" data-path="src/components/Testimonials.tsx">
            <div data-id="4t0sdcw0d" data-path="src/components/Testimonials.tsx">
              <h3 className="text-3xl font-bold mb-4" data-id="8z0turbi1" data-path="src/components/Testimonials.tsx">
                Garantía de Satisfacción Total
              </h3>
              <p className="text-lg opacity-90 mb-6" data-id="c9cu79r31" data-path="src/components/Testimonials.tsx">
                Estamos tan seguros de la calidad de nuestro trabajo que ofrecemos garantía de satisfacción total. 
                Si no quedas completamente satisfecho, corregimos cualquier problema sin costo adicional.
              </p>
              <div className="flex flex-wrap gap-4" data-id="j96jm9nqm" data-path="src/components/Testimonials.tsx">
                <Badge className="bg-white/20 text-white px-4 py-2" data-id="btbotgmhm" data-path="src/components/Testimonials.tsx">
                  ✅ Garantía de por vida
                </Badge>
                <Badge className="bg-white/20 text-white px-4 py-2" data-id="e2ag041vh" data-path="src/components/Testimonials.tsx">
                  🔧 Soporte técnico incluido
                </Badge>
                <Badge className="bg-white/20 text-white px-4 py-2" data-id="o9ur9d326" data-path="src/components/Testimonials.tsx">
                  📞 Asistencia 24/7
                </Badge>
              </div>
            </div>
            
            <div className="text-center" data-id="qkw3enz5y" data-path="src/components/Testimonials.tsx">
              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm" data-id="zq59zfh10" data-path="src/components/Testimonials.tsx">
                <div className="text-6xl mb-4" data-id="7x5cwmvrj" data-path="src/components/Testimonials.tsx">💯</div>
                <div className="text-2xl font-bold mb-2" data-id="lzdnnh1cq" data-path="src/components/Testimonials.tsx">100% Satisfacción</div>
                <div className="text-sm opacity-75" data-id="43gn3ecwm" data-path="src/components/Testimonials.tsx">
                  Garantizada en todos nuestros proyectos
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Videos Demo */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-xl" data-id="bjeermu5d" data-path="src/components/Testimonials.tsx">
          <div className="text-center mb-8" data-id="f829qw64m" data-path="src/components/Testimonials.tsx">
            <h3 className="text-3xl font-bold text-gray-900 mb-4" data-id="aourubvw7" data-path="src/components/Testimonials.tsx">
              Videos Demo
            </h3>
            <p className="text-gray-600" data-id="eudrkv421" data-path="src/components/Testimonials.tsx">
              Descubre la potencia de la automatización con nuestros videos demostrativos
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6" data-id="yeiaq52s0" data-path="src/components/Testimonials.tsx">
            <div className="rounded-lg overflow-hidden shadow-lg" data-id="tsmscy4bw" data-path="src/components/Testimonials.tsx">
              <iframe
                src="https://www.youtube.com/embed/MbOWj9cp0WI?start=5"
                title="Cine en casa - Automatiza.me"
                className="w-full h-64"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen data-id="ls91wsfyu" data-path="src/components/Testimonials.tsx" />

              <div className="p-4 bg-gray-50" data-id="5rex25sxw" data-path="src/components/Testimonials.tsx">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="n83pfrhmb" data-path="src/components/Testimonials.tsx">Cine en Casa</h4>
                <p className="text-gray-600 text-sm" data-id="lcayvtsf5" data-path="src/components/Testimonials.tsx">Experimenta la automatización completa de tu sistema de entretenimiento</p>
              </div>
            </div>
            
            <div className="rounded-lg overflow-hidden shadow-lg" data-id="h4ax4kj9v" data-path="src/components/Testimonials.tsx">
              <iframe
                src="https://www.youtube.com/embed/txX0mA5L7g4"
                title="Fibaro Swipe - Automatiza.me"
                className="w-full h-64"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen data-id="3tc9y38xd" data-path="src/components/Testimonials.tsx" />

              <div className="p-4 bg-gray-50" data-id="ywwtdu20f" data-path="src/components/Testimonials.tsx">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="m6gt1gv0l" data-path="src/components/Testimonials.tsx">Fibaro Swipe</h4>
                <p className="text-gray-600 text-sm" data-id="00rbzm8zv" data-path="src/components/Testimonials.tsx">Control gestual avanzado para tu hogar inteligente</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default Testimonials;